import { getGeoValueByType } from '@/packages/JsonQuery';
import { type IJsonQueryUnderground } from '@/packages/api-models/common/json_query';

import { type IUndergroundGeoTag } from '../../../../../types/geoTags';
import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagGeoUndergroundSchema } from '../types';

export const geoUnderground: ITagGroupConfig = {
  get({ jsonQuery, geoTags }) {
    const jqValues = getGeoValueByType<IJsonQueryUnderground>('underground')(jsonQuery);
    if (!jqValues) {
      return null;
    }

    const tagsGroup: TagGeoUndergroundSchema[] = jqValues.map(jqValue => {
      const geoTagData: IUndergroundGeoTag = geoTags.underground.find(({ id }) => id === jqValue.id) || {
        type: 'underground',
        name: `Неизвестная станция #${jqValue.id}`,
        id: jqValue.id,
        color: null,
        releaseYear: null,
        underConstruction: false,
      };

      return {
        group: 'geoUnderground',
        text: geoTagData.name,
        data: geoTagData,
      };
    });

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ onChange }, tag: TagGeoUndergroundSchema) {
    onChange({
      action: 'removeGeo',
      arguments: [{ type: 'underground', id: tag.data.id }],
    });
  },
};
